<template>
  <template-list scrollEl="#app" :projectId="$store.state.app.projectId"></template-list>
</template>

<script>
    import routerMixin from '@/mixins/router-mixin.js';
    import templateList from '../components/template/template-list-index'
    export default {
        components: {
            templateList
        },
        mixins: [routerMixin],
        data() {
            return {
            }
        },
        beforeDestroy() {
        },
        created() {
        },
    }
</script>
<style lang="scss">
  @import './template.scss';
</style>
